interface WhistllLogoProps {
  /** Pixel size of the icon (width). Height is derived automatically. */
  size?: number;
  className?: string;
  /** Use a specific hex/var colour. Defaults to the volt accent. */
  color?: string;
}

/**
 * Whistll logomark: a ring with a vertical line through it, the line
 * extending slightly past the top and bottom of the circle. Mirrors the
 * SVG in apps/mobile/src/components/shared/LineUpLogo.jsx.
 *
 * Icon only. Pair with <Wordmark /> for the full lockup.
 */
export function WhistllLogo({
  size = 28,
  className,
  color = "hsl(var(--volt))",
}: WhistllLogoProps) {
  const strokeWidth = size * 0.11;
  const cx = size / 2;
  const cy = size / 2;
  const r = size * 0.33;
  const lineTop = cy - r - strokeWidth * 0.5 - size * 0.04;
  const lineBottom = cy + r + strokeWidth * 0.5 + size * 0.04;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <circle
        cx={cx}
        cy={cy}
        r={r}
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
      />
      <line
        x1={cx}
        y1={lineTop}
        x2={cx}
        y2={lineBottom}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}
